import React from 'react'
import Box from '@mui/material/Box'

const IS_DEV = process.env.NODE_ENV === 'development'

/**
 * Overlay de depuración (solo en desarrollo) que muestra el zoom actual del mapa
 * en tiempo real. No se renderiza en producción.
 *
 * @param {Object} props
 * @param {import('mapbox-gl').Map | null} props.map - Instancia del mapa de Mapbox
 */
const ZoomDebugOverlay = ({ map }) => {
  const [zoom, setZoom] = React.useState(null)

  React.useEffect(() => {
    if (!IS_DEV || !map) return undefined

    const updateZoom = () => setZoom(map.getZoom())
    updateZoom()
    map.on('zoom', updateZoom)

    return () => {
      map.off('zoom', updateZoom)
    }
  }, [map])

  if (!IS_DEV || zoom === null) return null

  return (
    <Box
      component="div"
      sx={{
        position: 'absolute',
        top: 'max(6vh, 65px)',
        right: 52,
        zIndex: 1001,
        px: 1,
        py: 0.5,
        borderRadius: 1,
        bgcolor: 'rgba(0, 0, 0, 0.7)',
        color: '#fff',
        fontFamily: 'monospace',
        fontSize: 12,
        lineHeight: 1.4,
        pointerEvents: 'none',
        userSelect: 'none',
      }}>
      zoom: {zoom.toFixed(2)}
    </Box>
  )
}

export default ZoomDebugOverlay
